"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var remote_data_ts_1 = require("@devexperts/remote-data-ts");
var Refresh_1 = __importDefault(require("@material-ui/icons/Refresh"));
// import Pagination from "components/generics/genericList/RaPagination";
var lodash_get_1 = __importDefault(require("lodash.get"));
var states_1 = require("./states");
var Pagination_1 = __importDefault(require("./Pagination"));
var lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
var SortLabel_1 = __importDefault(require("./TableHeader/SortLabel"));
var usePagination = function (pagesNIndexed, defaultSize) {
    if (defaultSize === void 0) { defaultSize = 10; }
    var _a = (0, react_1.useReducer)(function (state, action) {
        switch (action.type) {
            case "SET_PAGE":
                return __assign(__assign({}, state), { page: action.page });
            case "SET_SIZE":
                return __assign(__assign({}, state), { size: action.size });
        }
        return state;
    }, { page: pagesNIndexed, size: defaultSize }), paginationState = _a[0], dispatch = _a[1];
    return [paginationState, dispatch];
};
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        headerCell: {
            position: "sticky",
            zIndex: 3,
            backgroundColor: theme.palette.background.paper,
            top: 0,
            paddingLeft: "1em",
        },
        offScreen: {
            position: "absolute",
            left: "-10000px",
            top: "auto",
            height: 0,
            width: 0,
            overflow: "hidden",
        },
    });
});
var HiddenAriaLive = function (props) {
    var remoteData = props.remoteData, _a = props.resourceDisplayName, resourceDisplayName = _a === void 0 ? "Results" : _a;
    var classes = useStyles();
    return (react_1.default.createElement("span", { "aria-live": "polite", "aria-atomic": "true", className: classes.offScreen }, (0, remote_data_ts_1.fold)(function () { return ""; }, function () { return "loading"; }, function (e) { return "Search failed: " + e.message; }, function (_a) {
        var data = _a.data, total = _a.total;
        return total > 0
            ? "Showing ".concat(data.length, " out of ").concat(total, " ").concat(resourceDisplayName)
            : "No ".concat(resourceDisplayName, " found");
    })(remoteData)));
};
var makeAdhocList = function () {
    var rowContext = react_1.default.createContext(null);
    var AdhocListColumn = function (props) {
        var rc = (0, react_1.useContext)(rowContext);
        if (!rc) {
            throw new Error("an <AdhocListColumn> must be a child of <AdhocList></AdhocList>");
        }
        var TableCellProps = props.firstColumn
            ? { component: "th", scope: "row" }
            : null;
        var rowData = rc.rowData, i = rc.i;
        if (props.renderdata) {
            var resultElement = props.renderdata((0, lodash_get_1.default)(rowData, props.fieldKey), rowData, i);
            if (resultElement.type !== core_1.TableCell) {
                throw new Error("render prop on AdhocListColumn must return a <TableCell> element\n          (Also ensure you are using a matching version of @material-ui/core)");
            }
            return resultElement;
        }
        var fieldData = (0, lodash_get_1.default)(rowData, props.fieldKey);
        var tableHeadingCellChildren = typeof fieldData === "string" || typeof fieldData === "number"
            ? fieldData
            : typeof fieldData === "object"
                ? "Unhandled Object Type"
                : undefined;
        return (react_1.default.createElement(core_1.TableCell, __assign({}, TableCellProps), tableHeadingCellChildren));
    };
    var AdhocList = function (props) {
        var _a = props.iconAndTextSize, iconAndTextSize = _a === void 0 ? "md" : _a, titleOptions = props.titleOptions;
        var sortCaptionId = (0, react_1.useMemo)(function () { return (0, lodash_uniqueid_1.default)("sort-caption-"); }, []);
        var initialTitleId = (0, react_1.useMemo)(function () { return (0, lodash_uniqueid_1.default)("list-title-label"); }, []);
        var titleId = (0, react_1.useRef)(initialTitleId);
        var classes = useStyles();
        var _b = (0, react_1.useState)(remote_data_ts_1.initial), state = _b[0], setState = _b[1];
        var _c = (0, react_1.useState)(props.initialFilter), filter = _c[0], setFilter = _c[1];
        var _d = usePagination(props.type === "paginated" ? props.pagesNIndexed : 0, props.type === "paginated" ? props.defaultSize : undefined), paginationState = _d[0], dispatch = _d[1];
        var initialSort = (0, react_1.useMemo)(function () {
            var _a, _b;
            return (_b = (props.children && !Array.isArray(props.children)
                ? [props.children]
                : (_a = props.children) !== null && _a !== void 0 ? _a : []).flatMap(function (child) {
                var initialSort = child.props.initialSort;
                if (!initialSort) {
                    return [];
                }
                return [[child.props.fieldKey, initialSort]];
            })[0]) !== null && _b !== void 0 ? _b : null;
        }, [props.children]);
        var _e = (0, react_1.useState)(initialSort), order = _e[0], setOrder = _e[1];
        var fetchData = (0, react_1.useCallback)(function () {
            var handleError = function (error) {
                setState((0, remote_data_ts_1.failure)(error));
            };
            setState(remote_data_ts_1.pending);
            var subscription = props.type === "paginated"
                ? props
                    .getDataObservable(__assign(__assign({}, paginationState), { orderBy: order, filter: filter }))
                    .subscribe(function (_a) {
                    var data = _a.data, total = _a.total;
                    setState((0, remote_data_ts_1.success)({
                        data: data,
                        total: total,
                    }));
                }, handleError)
                : props
                    .getDataObservable({ filter: filter, orderBy: order })
                    .subscribe(function (res) {
                    setState((0, remote_data_ts_1.success)({
                        data: res,
                        total: res.length,
                    }));
                }, handleError);
            return function () {
                if (!subscription.closed) {
                    subscription.unsubscribe();
                }
            };
            // eslint seems to be having trouble due to the type discrimination I'm doing.
            // (It demands I pass 'props'.) Lets just eyeball that this is correct.
        }, [
            setState,
            props.type,
            props.getDataObservable,
            paginationState,
            filter,
            order,
        ]);
        (0, react_1.useEffect)(function () {
            return fetchData();
        }, [paginationState.page, paginationState.size, order === null || order === void 0 ? void 0 : order[0], order === null || order === void 0 ? void 0 : order[1]]); // eslint-disable-line
        var TableProps = (0, react_1.useMemo)(function () {
            if (titleOptions.type === "Typography" ||
                titleOptions.type === "aria-labelled-by" ||
                titleOptions.type === "render") {
                return {
                    "aria-labelledby": titleId.current,
                };
            }
            return {
                "aria-label": titleOptions.text,
            };
        }, []);
        var containsSomeSort = (0, react_1.useMemo)(function () {
            var _a;
            return (_a = (props.children && !Array.isArray(props.children)
                ? [props.children]
                : props.children)) === null || _a === void 0 ? void 0 : _a.some(function (f) { return f.props.sortable !== false; });
        }, [props.children]);
        var renderTable = function (state) {
            var _a, _b, _c, _d, _e;
            var data = state.data, total = state.total;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between" } },
                    titleOptions.type === "Typography" ? (react_1.default.createElement(core_1.Typography, __assign({ id: titleId.current }, titleOptions.TypographyProps), titleOptions.text)) : titleOptions.type === "aria-labelled-by" ||
                        titleOptions.type === "aria-label" ? null : (titleOptions.render(titleId.current)),
                    props.hasRefresh && (react_1.default.createElement("div", null,
                        react_1.default.createElement(core_1.IconButton, { "aria-label": "Refresh", onClick: fetchData },
                            react_1.default.createElement(Refresh_1.default, null))))), (_b = (_a = props.renderBelowTitle) === null || _a === void 0 ? void 0 : _a.call(props)) !== null && _b !== void 0 ? _b : null, (_e = (_d = (_c = props).renderFilter) === null || _d === void 0 ? void 0 : _d.call(_c, {
                filter: filter,
                setFilter: setFilter,
                fetchData: fetchData,
            })) !== null && _e !== void 0 ? _e : null,
                total === 0 && props.renderNoResults ? (props.renderNoResults({
                    refresh: fetchData,
                })) : (react_1.default.createElement(core_1.Table, __assign({}, TableProps),
                    react_1.default.createElement("caption", { className: classes.offScreen },
                        props.tableCaption,
                        containsSomeSort && (react_1.default.createElement("span", { id: sortCaptionId }, ", use column header buttons to sort"))),
                    react_1.default.createElement(core_1.TableHead, null,
                        react_1.default.createElement(core_1.TableRow, null, react_1.default.Children.map(props.children, function (c, i) {
                            var title = c.props.hideColTitle ? (react_1.default.createElement("span", { className: classes.offScreen }, c.props.title)) : (c.props.title);
                            if (c.props.sortable) {
                                return (react_1.default.createElement(core_1.TableCell, { className: classes.headerCell, padding: "none", sortDirection: (order === null || order === void 0 ? void 0 : order[0]) === c.props.fieldKey ? order === null || order === void 0 ? void 0 : order[1] : false },
                                    react_1.default.createElement(core_1.Tooltip, { title: "Sort", enterDelay: 300 },
                                        react_1.default.createElement(SortLabel_1.default, { ButtonProps: {
                                                onClick: function (e) {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    var selectedFieldKey = c.props.fieldKey;
                                                    setOrder(function (currOrder) {
                                                        var fieldPath = Array.isArray(selectedFieldKey)
                                                            ? selectedFieldKey.join(".")
                                                            : selectedFieldKey;
                                                        if (!currOrder) {
                                                            return [fieldPath, "asc"];
                                                        }
                                                        var currField = currOrder[0], currDir = currOrder[1];
                                                        if (currField === fieldPath) {
                                                            return [
                                                                currField,
                                                                currDir === "asc" ? "desc" : "asc",
                                                            ];
                                                        }
                                                        return [fieldPath, "asc"];
                                                    });
                                                },
                                                "aria-describedby": sortCaptionId,
                                            }, label: title, active: order
                                                ? order[0] === c.props.fieldKey
                                                : undefined, direction: order === null || order === void 0 ? void 0 : order[1] }))));
                            }
                            return react_1.default.createElement(core_1.TableCell, { key: i }, title);
                        }))),
                    react_1.default.createElement(core_1.TableBody, null, data.map(function (rowData, i) { return (react_1.default.createElement(rowContext.Provider, { key: i, value: {
                            rowData: rowData,
                            i: i,
                        } },
                        react_1.default.createElement(core_1.TableRow, null, react_1.default.Children.map(props.children, function (c, i) {
                            return i === 0
                                ? react_1.default.cloneElement(c, { firstColumn: true })
                                : c;
                        })))); })))),
                props.type === "paginated" && (react_1.default.createElement(Pagination_1.default, { maxExactTotalCount: props.maxExactTotalCount, page: paginationState.page + (props.pagesNIndexed === 0 ? 1 : 0), perPage: paginationState.size, setPage: function (page) {
                        dispatch({
                            type: "SET_PAGE",
                            page: props.pagesNIndexed === 0 ? page - 1 : page,
                        });
                    }, setPerPage: function (size) {
                        dispatch({
                            type: "SET_SIZE",
                            size: size,
                        });
                    }, rowsPerPageOptions: (function () {
                        if (props.paginationOptions) {
                            if (typeof props.paginationOptions === "number") {
                                return [props.paginationOptions];
                            }
                            return props.paginationOptions;
                        }
                        var drpp = [5, 10, 25, 100];
                        if (drpp.includes(props.defaultSize)) {
                            return drpp;
                        }
                        return __spreadArray([props.defaultSize], drpp, true).sort();
                    })(), total: total }))));
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(HiddenAriaLive, { remoteData: state }),
            (0, remote_data_ts_1.fold)(function () { return react_1.default.createElement(states_1.Pending, { size: iconAndTextSize }); }, function () { return react_1.default.createElement(states_1.Pending, { size: iconAndTextSize }); }, function (error) {
                return error.status ? (react_1.default.createElement(states_1.ServerError, { size: iconAndTextSize, code: error.status, message: error.message })) : (react_1.default.createElement(states_1.NetworkUnavailable, { size: iconAndTextSize, retry: fetchData }));
            }, renderTable)(state)));
    };
    return {
        AdhocList: AdhocList,
        AdhocListColumn: AdhocListColumn,
    };
};
exports.default = makeAdhocList;
//# sourceMappingURL=makeAdhocList.js.map